module.exports = __webpack_public_path__ + "static/img/mengte_03.9599c21.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mengte_03.png
// module id = 52KS
// module chunks = 0